import React, {Fragment, useEffect, useRef, useState} from "react";
import {Chart, Axis, Tooltip, Annotation, Line, GComponents, Schema, Legend} from 'bizcharts';
import {connect} from "react-redux";
import {getIndicators} from "actions/IndicatorsActions";
// import Spinner from "../../../../components/common/Spinner";


// reactstrap components
import {
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Card,
    CardTitle,
    CardHeader,
    CardBody,
    Row,
    Col, Spinner
} from "reactstrap";

import {
    clearData,
    clearPrevious,
    removePlotPoint,
    deletePreviousFilter,
    setActivePlot,
    getData, getUserData, getHospital
} from "actions";

import VerticalBar from "./VerticalBar";
import IndicatorDescription from "../ComparativeIndicators/IndicatorDescription";
import LineChart from "../../../../components/indicatorsComponets/Plot/LineChart";
import {setIndicator} from "../../../../actions";

const {
    Canvas,
} = GComponents;

const MyIndicatorChart = ({
                              PlotData: {plot_data, user_plot_data, loading, hide_data, stats, active_plot, refresh},
                              Filters: {active_filter, refresh_filter, previous_filter, start_date, end_date,available_filters},
                              Indicators: {available_indicators, active_indicators},
                              getData,
                              getUserData,
                              clearData,
                              deletePreviousFilter,
                              clearPrevious,
                              getHospital,
                              removePlotPoint,
                              setActivePlot,
                            setPreviousFilter,
    setIndicator
                          }) => {
    const [displayData, SetData] = useState([]);
    const [index, setIndex] = useState(0);
    const dv = useRef(null)
    const [scaleData, setScale] = useState({
        nazwa_regionu: {
            sync: true,
        },
        "range": {

            max: 10,
            min: -10,
            nice: "true"
        },
        "wartosc_wskaznika": {
            max: 10,
            min: -10,
        }
    });

    const getDataRuqest = () => {

        if (active_indicators.length > 0) {
            const opk = previous_filter[active_plot] ? Object.values(previous_filter[active_plot])[0] : "none"
            getUserData(active_indicators, start_date, end_date, opk,previous_filter);
        }

        if (active_indicators.length !== Object.keys(user_plot_data).length) {
            let keys = Object.keys(user_plot_data);
            let difference = keys.filter(x => !active_indicators.includes(x));

            difference.map(x => {
                if(previous_filter.hasOwnProperty(x))
                    deletePreviousFilter({x:"none"},"myindicatorchart87");
                removePlotPoint(x)
            });


        }
    }
    useEffect(() => {
        const asyncWrapper = async () => { 
            clearData();
            clearPrevious();
        }
        if (active_indicators.length !== 0 && (active_indicators.length > Object.keys(user_plot_data).length)) {
            getDataRuqest()
        }


        if (active_indicators.length === 0) {
            asyncWrapper()
            SetData([]);
        }


    }, [active_indicators]);
    useEffect(() => {
        getDataRuqest()
    }, [start_date, end_date]);
    useEffect(() => {
        if (active_indicators.length !== 0) {
            getDataRuqest()
        }

    }, [refresh_filter]);

    useEffect(() => {
        getHospital();
        setIndicator("Wskaźnik zyskowności netto");
    }, [])


    //UseEffect ustawie aktywny wykres na podstawie dostarczonego id z aktywnych wskaźników
    useEffect(() => {
        if (active_indicators.length !== Object.keys(user_plot_data).length) {
            let keys = Object.keys(user_plot_data);
            let difference = active_indicators.filter(x => !keys.includes(x));
            if (difference.includes(Object.keys(user_plot_data)[index])) {
                setIndex(0)
                setActivePlot(active_indicators[0]);
            }
        } else
            setActivePlot(active_indicators[index]);
    }, [index, user_plot_data]);


    useEffect(() => {
        // SetData(plot_data.filter(dataPoint => !hide_data.includes(dataPoint.nazwa_regionu)))
        if (!user_plot_data.hasOwnProperty(active_plot)) {

            if (index === Object.keys(user_plot_data).length && Object.keys(user_plot_data).length !== 0) {
                setIndex(index - 1);
            }
            return;
        }


        if (index === Object.keys(user_plot_data).length && Object.keys(user_plot_data).length !== 0) {
            setIndex(index - 1);
        }

    }, [plot_data, hide_data, refresh, active_plot, active_indicators]);




    const getValueType = () => {
        let indicator = available_indicators.filter(indicator => indicator.nazwa === active_plot)
        if (indicator[0]) {
            if (indicator[0].value_type === null) {
                return ""
            } else {
                return indicator[0].value_type
            }
        }
        return ""


    }

    const getNoFilterId = () =>{
        if(Object.keys(available_filters.length>0)){
          let NoFilter =  available_filters.filter(x=>x.nazwa === "wojewodztwo")[0];
          if(NoFilter){
              return NoFilter.id
          }

        }

    }


    const getActiveFiltersName = () =>{
        if(previous_filter.hasOwnProperty(active_plot)) {
            const active_filter = previous_filter[active_plot]
            if(active_filter.hasOwnProperty(getNoFilterId())){
                return ""
            }
           const results = Object.entries(active_filter).map(filter=>{
               const found = available_filters.filter(x=>x.id == filter[0])[0]
               if(found.pola ==="opk_select"){
                   if (filter[1] !=="none"){
                       return "Nr OPK: "+filter[1]
                   }
               }
               else{
                   const subfilter = JSON.parse(found.pola).filter(x=>x[0]==filter[1])[0]
                   if(subfilter && subfilter.length ===2){
                       return subfilter[1]
                   }

               }
               return ""
           })
              let return_string =''
            results.forEach(item=>{
                if(item){
                    return_string = return_string + item + ", "
                }
            })
            if(return_string.length > 2){
                return_string = return_string.substring(0, return_string.length - 2)
            }
            return return_string


        }
        else
            return ""


    }
    return (
       <>{!loading  &&  active_indicators.length !== 0 ?( <Col xl="10" md="9" sm="12">
            <Row >
                <Col md="12">
                <Card style={{"width":"100%"}}>
                    <CardBody>
                        <div className="nav-tabs-navigation mb-0" style={{borderBottom:"none"}}>
                            <div className="nav-tabs-wrapper">
                                <Nav id="tabs" role="tablist" tabs>
                                    {active_indicators.map((inidicatior_name, idx) => {
                                        return (
                                            <NavItem key={inidicatior_name+idx*3}>
                                                <NavLink
                                                    aria-expanded={index === idx}
                                                    data-toggle="tab"
                                                    // href="#pablo"
                                                    role="tab"
                                                    className={index === idx ? "active wskaznikiPanel" : ""}
                                                    onClick={() => setIndex(idx)}
                                                    style={{cursor:"pointer"}}
                                                >
                                                    {`${inidicatior_name}`}
                                                </NavLink>
                                            </NavItem>
                                        )
                                    })}
                                </Nav>
                            </div>
                        </div>
                    </CardBody>
                </Card>
                </Col>
            </Row>
            <Row>
                <Col xl="8" md="9" sm="8">
                <Card>
                    <CardBody>


                        <TabContent
                            className="text-center"
                            id="my-tab-content"
                            activeTab={index}
                        >

                            {Object.values(active_indicators).map((indicatorKey, id) => {
                                return (
                                    <TabPane key={id} tabId={id} role="tabpanel">
                                        <VerticalBar displayData={user_plot_data[indicatorKey] ? user_plot_data[active_plot]: [] } loading
                                                     name={active_plot}
                                                     value_type={getValueType()} title={getActiveFiltersName()}
                                                     start={start_date} end={end_date}/>
                                    </TabPane>
                                )
                            })}
                        </TabContent>
                        <br/>

                    </CardBody>
                </Card>
                </Col>
                <Col xl="4" md="3" sm="4" className="align-baseline">

                        <IndicatorDescription/>

                            <LineChart value_type={getValueType()}  name={active_plot} title={getActiveFiltersName()}/>

                </Col>
            </Row>
        </Col>) :(<Col xl="10" md="9" sm="12"><Card>
            <CardHeader>
                <CardTitle className='text-center h4'>Wybierz wskaźniki, aby wyświetlić wykres</CardTitle>
            </CardHeader>
            <CardBody>
                <Row className='text-center'>
                    <Col className='ml-auto mr-auto'>
                        {/*<Spinner/>*/}
                    </Col>
                </Row>
            </CardBody>
       </Card></Col>)}</>


    )


};

// export default IndicatorList
const mapStateToProps = state => ({
    PlotData: state.PlotData,
    Indicators: state.Indicators,
    Filters: state.Filters,

});


export default connect(mapStateToProps, {
    setActivePlot,
    clearData,
    getData,
    getUserData,
    deletePreviousFilter,
    removePlotPoint,
    clearPrevious,
    getHospital,
    setIndicator
})(MyIndicatorChart);


